import React, { useState } from 'react';
import image1 from '../img/envision/utilites/cards/utiliti5.jpg';
import image2 from '../img/envision/utilites/cards/utiliti1.jpg';
import image3 from '../img/envision/utilites/cards/utiliti2.jpg';

const Utilitesanimatedcards = () => {
  const [currentIndex, setCurrentIndex] = useState(1); // Default to second item

  const carouselItems = [
    {
      imgSrc: image1,
      altText: "dog",
      title: "Enabling Eco-Friendly Engine Innovation",
      description: "design expertise delivers a next-gen sustainable aero engine, surpassing current models with a 16% fuel burn reduction, slashing emissions by 50%, reducing aircraft noise footprints by more than 75%."

    },
    {
      imgSrc: image2,
      altText: "dog",
      title: "Enabling Eco-Friendly Engine Innovation",
      description: "design expertise delivers a next-gen sustainable aero engine, surpassing current models with a 16% fuel burn reduction, slashing emissions by 50%, reducing aircraft noise footprints by more than 75%."

    },
    {
      imgSrc: image3,
      altText: "dog",
      title: "Enabling Eco-Friendly Engine Innovation",
      description: "design expertise delivers a next-gen sustainable aero engine, surpassing current models with a 16% fuel burn reduction, slashing emissions by 50%, reducing aircraft noise footprints by more than 75%."

    },
    {
      imgSrc: image1,
      altText: "dog",
      title: "Enabling Eco-Friendly Engine Innovation",
      description: "design expertise delivers a next-gen sustainable aero engine, surpassing current models with a 16% fuel burn reduction, slashing emissions by 50%, reducing aircraft noise footprints by more than 75%."

    },
    {
      imgSrc: image2,
      altText: "dog",
      title: "Enabling Eco-Friendly Engine Innovation",
      description: "design expertise delivers a next-gen sustainable aero engine, surpassing current models with a 16% fuel burn reduction, slashing emissions by 50%, reducing aircraft noise footprints by more than 75%."

    },
    {
      imgSrc: image3,
      altText: "dog",
      title: "Enabling Eco-Friendly Engine Innovation",
      description: "design expertise delivers a next-gen sustainable aero engine, surpassing current models with a 16% fuel burn reduction, slashing emissions by 50%, reducing aircraft noise footprints by more than 75%."

    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === carouselItems.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? carouselItems.length - 1 : prevIndex - 1));
  };

  return (
    <div> <h1 style={{ textAlign: 'center', marginTop: '40px', marginBottom: '-20px' }} >Spotlight <span style={{ color: '#0785a3' }}> Stories</span></h1>
      <div className="carousel-container">
        <div className="carousel">
          {carouselItems.map((item, index) => {
            let itemClass = 'carousel__item';
            if (index === currentIndex) {
              itemClass += ' carousel__item--main';
            } else if (index === currentIndex - 1 || (currentIndex === 0 && index === carouselItems.length - 1)) {
              itemClass += ' carousel__item--left';
            } else if (index === currentIndex + 1 || (currentIndex === carouselItems.length - 1 && index === 0)) {
              itemClass += ' carousel__item--right';
            }

            return (
              <div key={index} className={itemClass}>
                <img src={item.imgSrc} alt={item.altText} />
                <div className="carousel__text">
                  <h6 style={{ marginBottom: '10px' }}>{item.title}</h6>
                  <p style={{ textAlign: 'justify', fontSize: '13px' }}>{item.description}</p>
                </div>
              </div>
            );
          })}

          <div className="carousel__btns">
            <button className="carousel__btn" onClick={prevSlide}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="currentColor" fillRule="evenodd" d="m15 4l2 2l-6 6l6 6l-2 2l-8-8z" />
              </svg>
            </button>
            <button className="carousel__btn" onClick={nextSlide}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="currentColor" fillRule="evenodd" d="m9.005 4l8 8l-8 8L7 18l6.005-6L7 6z" />
              </svg>
            </button>
          </div>
        </div>

        <style jsx>{`
    .carousel-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 104vh;
      margin-top:-80px;
    }

    .carousel {
      position: relative;
      max-width: 1200px;
    }

    .carousel__item {
      position: absolute;
      height: 23rem; /* Base height */
      width: 22rem;  /* Base width */
      border-radius: 3px;
      overflow: hidden;
      box-shadow: 0 1rem 4rem rgba(0, 0, 0, 0.5);
      transform: translate(-50%, -50%) scale(0.5);
      z-index: 0;
      transition: all 0.3s ease;
    }

    .carousel__item img {
      width: 100%;
      height: 100%;
    //   object-fit: cover;
    }

  .carousel__item--main {
  transform: translate(-50%, -50%) scaleX(1.5) scaleY(1.2); /* Further increase width */
  z-index: 3;
}

.carousel__item--left {
  transform: translate(-140%, -50%) scaleX(1.5) scaleY(0.7); /* Further increase width */
  z-index: 1;
}

.carousel__item--right {
  transform: translate(30%, -50%) scaleX(1.5) scaleY(0.7); /* Further increase width */
  z-index: 1;
}


    .carousel__item--left img,
    .carousel__item--right img {
      filter: grayscale(80%);
    }

    .carousel__item:hover > .carousel__text {
      opacity: 1;
    }

    .carousel__text {
      position: absolute;
      bottom: 0;
      z-index: 4;
      opacity: 0;
      transition: opacity 0.2s;
      width: 100%;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 2rem 1rem;
      color: #fff;
    }

    .carousel__btns {
      position: absolute;
      transform: translate(-50%, 22rem);
      display: flex;
      gap: 2rem;
      margin-top: -45px;
    }

    .carousel__btn {
      background-color: #05859d;
      height: 4rem;
      width: 4rem;
      border-radius: 50%;
      border: 1px solid currentColor;
      color: #fff;
      cursor: pointer;
    }

    .carousel__btn svg {
      height: 1.8rem;
      width: 1.8rem;
    }

    .carousel__btn:hover {
      color: #aaa;
    }
      .title{
      color: #fff;
      }
      .description{
      text-align: justify;
      }
  `}</style>
      </div>
    </div>
  );
};

export default Utilitesanimatedcards;
